export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

/**
 * 登录入口（论坛 OAuth）。
 *
 * 之前这里生成的是 Manus 的 app-auth 链接（manus.im）。
 * 现在统一改为走站内 /login 页面，再由后端生成论坛 OAuth 授权地址。
 */
export const getLoginUrl = () => {
  return `${window.location.origin}/login`;
};
